import { api } from "@/services/api";

import {
  AppDataModel,
  LoginResponse,
  TermsAndPrivacyResponse,
  UserDetailModel,
} from "../types";

const loginApi = api.injectEndpoints({
  endpoints: (build) => ({
    authenticateUser: build.mutation<LoginResponse, any>({
      query: (payload) => {
        return {
          url: "api/Account/ValidateUser",
          method: "post",
          data: payload,
        };
      },
    }),
    registerUser: build.mutation<LoginResponse, any>({
      query: (payload) => {
        return {
          url: "api/Account/SignUp",
          method: "post",
          data: payload,
        };
      },
    }),
    getAppData: build.mutation<AppDataModel, void>({
      query: (payload) => {
        return {
          url: "api/Account/GetAppData",
          method: "post",
          data: payload,
        };
      },
    }),
    updateProfile: build.mutation<boolean, UserDetailModel>({
      query: (payload) => {
        return {
          url: "api/Account/CompleteRegistration",
          method: "post",
          data: payload,
        };
      },
    }),
    getTermsAndPolicy: build.mutation<TermsAndPrivacyResponse, string>({
      query: (payload) => {
        return {
          url: "api/Account/GetTermsAndPolicy",
          method: "post",
          data: payload,
        };
      },
    }),
    verifyCaptchaToken: build.mutation<any, string>({
      query: (payload) => {
        return {
          url: "api/Account/VerifyCaptchaToken",
          method: "post",
          data: payload,
        };
      },
    }),
    externalLogin: build.mutation<LoginResponse, any>({
      query: (payload) => {
        return {
          url: "api/Account/ExternalLogin",
          method: "post",
          data: payload,
        };
      },
    }),
    getTwitterLoginUrl: build.query<any, void>({
      query: (payload) => {
        return {
          url: "api/Account/GetTwitterLoginUrl",
          method: "get",
          data: payload,
        };
      },
    }),
    getTwitterUserInfo: build.mutation<any, string>({
      query: (payload) => {
        return {
          url: "api/Account/GetTwitterUserInfo",
          method: "post",
          data: payload,
        };
      },
    }),
    registerMerchantUser: build.mutation<LoginResponse, any>({
      query: (payload) => {
        return {
          url: "api/Account/SignUpMerchant",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useAuthenticateUserMutation,
  useRegisterUserMutation,
  useGetAppDataMutation,
  useUpdateProfileMutation,
  useGetTermsAndPolicyMutation,
  useVerifyCaptchaTokenMutation,
  useExternalLoginMutation,
  useLazyGetTwitterLoginUrlQuery,
  useGetTwitterUserInfoMutation,
  useRegisterMerchantUserMutation,
} = loginApi;

export default loginApi;
